export const DOCK_NAV_ROW_CLASSES =
  "flex h-9 w-full items-center gap-3 rounded-md px-3 py-2 transition-colors duration-150 ease-linear hover:bg-active hover:text-selector-active";

export const DOCK_NAV_ACTIVE_CLASSES = "bg-active text-selector-active";

export const DOCK_NAV_ICON_BUTTON_CLASSES =
  "flex size-9 shrink-0 items-center justify-center rounded-md text-default transition-colors duration-150 ease-linear hover:bg-active hover:text-selector-active";

export const DOCK_NAV_SUBLINK_CLASSES =
  "hover:bg-active hover:text-selector-active text-default flex items-center gap-3 rounded-md px-3 py-2 transition-colors duration-150 ease-linear";
